/* ===== GAME DAY SKINZ HELMET CONFIGURATOR ===== */
(function() {
  'use strict';

  // ============================================================
  // CONFIG
  // ============================================================
  var ART_TEAM_EMAIL = 'art@gamedayskinz.com'; // TODO: confirm correct email

  // Build a metallic-sheen CSS gradient string from a base hex color.
  // Matches the visual treatment used on colors.html for metallic swatches.
  function metalGradient(hex) {
    var r = parseInt(hex.slice(1,3),16);
    var g = parseInt(hex.slice(3,5),16);
    var b = parseInt(hex.slice(5,7),16);
    var lighter = 'rgb(' + Math.min(255,r+60) + ',' + Math.min(255,g+60) + ',' + Math.min(255,b+60) + ')';
    var darker = 'rgb(' + Math.max(0,r-30) + ',' + Math.max(0,g-30) + ',' + Math.max(0,b-30) + ')';
    return 'linear-gradient(135deg, ' + lighter + ' 0%, ' + hex + ' 40%, ' + darker + ' 70%, ' + lighter + ' 100%)';
  }

  // ============================================================
  // PALETTES (from colors.html reference)
  // ============================================================
  // RIDDELL_GLOSS: official Riddell stock helmet paint codes (gloss finish).
  // Used as the SHELL color palette since these are real Riddell production colors.
  var RIDDELL_GLOSS = [
    {name:'White',hex:'#ffffff'},
    {name:'Black',hex:'#1a1a1a'},
    {name:'Scarlet',hex:'#cc1010'},
    {name:'Maroon',hex:'#6e0a18'},
    {name:'Sunflower Gold',hex:'#e8a800'},
    {name:'Burnt Orange',hex:'#c84800'},
    {name:'Kelly Green',hex:'#188030'},
    {name:'Navy',hex:'#0a1440'},
    {name:'Forest Green',hex:'#0a3818'},
    {name:'Gold',hex:'#c89020'},
    {name:'Texas Blue',hex:'#6090c8'},
    {name:'Light Gold',hex:'#d8b840'},
    {name:'Old Gold',hex:'#a87820'},
    {name:'South Bend Gold',hex:'#b89030'},
    {name:'Purple',hex:'#501090'},
    {name:'Bay Silver',hex:'#9898a8'},
    {name:'Yellow',hex:'#f0d000'},
    {name:'Texas Orange',hex:'#c84000'},
    {name:'Kansas Blue',hex:'#0050c0'},
    {name:'Pearl Red',hex:'#c81828'},
    {name:'Memphis Blue',hex:'#2858a0'},
    {name:'Lt Columbia Blue',hex:'#80b0d8'},
    {name:'Hornet Gold',hex:'#d8a010'},
    {name:'Dark Old Gold',hex:'#906010'},
    {name:'Seal Brown',hex:'#583018'},
    {name:'Red Extra Bright',hex:'#e00808'},
    {name:'Black Ext Bright',hex:'#101010'},
    {name:'Columbia Blue',hex:'#6098c8'},
    {name:'Missouri Red',hex:'#c01020'},
    {name:'Bay Gold',hex:'#c89828'},
    {name:'Vegas Gold',hex:'#c8a840'},
    {name:'Royal Blue',hex:'#0820b0'},
    {name:'Extra Bright Silver',hex:'#d8d8d8'},
    {name:'Penn Green',hex:'#0a5828'},
    {name:'Cardinal',hex:'#9e1020'},
    {name:'Pearl Cardinal',hex:'#b01828'},
    {name:'Sun Gold',hex:'#e0a808'},
    {name:'Harvest Gold',hex:'#c88818'},
    {name:'Youth Purple',hex:'#6020a8'},
    {name:'Youth Kelly',hex:'#108028'},
    {name:'Youth Royal',hex:'#1028b0'},
    {name:'Fall Gold',hex:'#d89010'},
    {name:'College Blue Metallic',hex:'#2060a8',metallic:true},
    {name:'Purple Metallic',hex:'#4818a0',metallic:true},
    {name:'Maroon Metallic',hex:'#700818',metallic:true},
    {name:'Ext Silver Metallic',hex:'#c8c8c8',metallic:true},
    {name:'Kelly Green Metallic',hex:'#107028',metallic:true},
    {name:'Sunflower Metallic',hex:'#e0a000',metallic:true},
    {name:'Navy Metallic',hex:'#0a1038',metallic:true},
    {name:'Royal Metallic',hex:'#0818a8',metallic:true},
    {name:'Red Metallic',hex:'#c00818',metallic:true},
    {name:'Black Metallic',hex:'#181818',metallic:true},
    {name:'White Metallic',hex:'#e8e8e8',metallic:true},
    {name:'Forest Green Metallic',hex:'#083018',metallic:true},
    {name:'Cardinal Metallic',hex:'#980818',metallic:true},
    {name:'Boston Blue Metallic',hex:'#1840a0',metallic:true},
    {name:'Seal Brown Metallic',hex:'#502808',metallic:true},
    {name:'Dark Brown Metallic',hex:'#401800',metallic:true},
    {name:'Pewter Metallic',hex:'#686878',metallic:true},
    {name:'Colorado Metallic',hex:'#e8a808',metallic:true},
    {name:'Gold Metallic',hex:'#c89020',metallic:true},
    {name:'Orange Metallic',hex:'#d04808',metallic:true},
    {name:'KY/KS Blue Metallic',hex:'#0840b8',metallic:true},
    {name:'Aqua Blue Metallic',hex:'#0898b8',metallic:true},
    {name:'Light Columbia Blue Metallic',hex:'#5898c8',metallic:true},
    {name:'Cobalt Blue Metallic',hex:'#0828b0',metallic:true}
  ];

  var GLOSS_PALETTE = [
    {name:'White',hex:'#ffffff'},{name:'Light Gray',hex:'#c8c8c8'},{name:'Silver',hex:'#a8a8a8'},
    {name:'Gray',hex:'#888888'},{name:'Traffic Gray',hex:'#6e6e6e'},{name:'Dk Gray',hex:'#4a4a4a'},
    {name:'Black',hex:'#1a1a1a'},{name:'Dk Brown',hex:'#4a2e1a'},{name:'Brown',hex:'#7a4a2a'},
    {name:'Beige',hex:'#d4c4a0'},{name:'Vegas Gold',hex:'#c8a84a'},{name:'Tan',hex:'#c8a878'},
    {name:'Gold',hex:'#c89820'},{name:'Dk Maroon',hex:'#4a0a14'},{name:'Burgundy',hex:'#6e1020'},
    {name:'Cardinal',hex:'#9e1020'},{name:'Ruby',hex:'#c01828'},{name:'Red',hex:'#d42020'},
    {name:'Fireball',hex:'#e83010'},{name:'Fluor Red',hex:'#ff2800'},{name:'TX Orange',hex:'#c84820'},
    {name:'Univ Orange',hex:'#e05018'},{name:'Orange',hex:'#e86010'},{name:'Sunflower',hex:'#f0a800'},
    {name:'Yellow',hex:'#f5d000'},{name:'Fluor Yellow',hex:'#e8e800'},{name:'Lime',hex:'#a0d000'},
    {name:'Fluor Green',hex:'#50e000'},{name:'Kelly',hex:'#188030'},{name:'Dk Green',hex:'#0a4818'},
    {name:'Forest',hex:'#0e3818'},{name:'Teal',hex:'#008070'},{name:'Light Blue',hex:'#70c0e0'},
    {name:'Carolina',hex:'#6890c8'},{name:'Cyan',hex:'#00a8d0'},{name:'Olympic',hex:'#0078c8'},
    {name:'True Blue',hex:'#0050b0'},{name:'Vivid',hex:'#0040a0'},{name:'Cobalt',hex:'#0030a0'},
    {name:'Royal',hex:'#0020a0'},{name:'Lt Navy',hex:'#1a2a60'},{name:'Navy',hex:'#0e1a40'},
    {name:'Pink',hex:'#f080a0'},{name:'Magenta',hex:'#e0208a'},{name:'Lilac',hex:'#c090d0'},
    {name:'Violet',hex:'#8030b0'},{name:'Purple',hex:'#5820a0'},{name:'Dk Purple',hex:'#300860'}
  ];

  var CHROME_PALETTE = [
    {name:'Silver',hex:'#c8c8c8'},{name:'Vegas',hex:'#c8b880'},{name:'Yellow',hex:'#e8c000'},
    {name:'Gold',hex:'#c89020'},{name:'Orange',hex:'#d85010'},{name:'TX Orange',hex:'#c04010'},
    {name:'Copper',hex:'#a05030'},{name:'Brown',hex:'#7a4020'},{name:'Red',hex:'#c01020'},
    {name:'Oklahoma Red',hex:'#900818'},{name:'Burgundy',hex:'#6e0818'},{name:'Pink',hex:'#d01880'},
    {name:'Violet',hex:'#7020a8'},{name:'Purple',hex:'#501090'},{name:'Cyan',hex:'#0090c0'},
    {name:'Vivid',hex:'#0038a0'},{name:'Blue',hex:'#0048b0'},{name:'Sapphire',hex:'#0028a0'},
    {name:'Royal',hex:'#0018a0'},{name:'Navy',hex:'#0a1438'},{name:'Lime',hex:'#90c800'},
    {name:'Oregon',hex:'#208030'},{name:'Green',hex:'#107820'},{name:'Dk Green',hex:'#083818'},
    {name:'BR Yellow',hex:'#d8d800'},{name:'BR Orange',hex:'#e84000'},{name:'BR Green',hex:'#40c000'}
  ];

  var PLATINUM_PALETTE = [
    {name:'Vegas',hex:'#c8b880'},{name:'Yellow',hex:'#e8c000'},{name:'Gold',hex:'#c89020'},
    {name:'Orange',hex:'#d85010'},{name:'TX Orange',hex:'#c04010'},{name:'Copper',hex:'#a05030'},
    {name:'Brown',hex:'#7a4020'},{name:'Red',hex:'#c01020'},{name:'Burgundy',hex:'#6e0818'},
    {name:'Pink',hex:'#d01880'},{name:'Violet',hex:'#7020a8'},{name:'Purple',hex:'#501090'},
    {name:'Cyan',hex:'#0090c0'},{name:'Vivid',hex:'#0038a0'},{name:'Blue',hex:'#0048b0'},
    {name:'Sapphire',hex:'#0028a0'},{name:'Royal',hex:'#0018a0'},{name:'Navy',hex:'#0a1438'},
    {name:'Lime',hex:'#90c800'},{name:'Oregon',hex:'#208030'},{name:'Green',hex:'#107820'},
    {name:'Dk Green',hex:'#083818'},{name:'BR Yellow',hex:'#d8d800'},{name:'BR Orange',hex:'#e84000'},
    {name:'BR Green',hex:'#40c000'}
  ];

  var PALETTE = GLOSS_PALETTE;

  function getDecalPalette() {
    return GLOSS_PALETTE;
  }

  // ============================================================
  // OPTIONS
  // ============================================================
  var FONTS = [
    {name:'Script',family:'AKTUELLE, cursive',weight:400, mixedCase:true},
    {name:'Army',family:'ARMY, sans-serif',weight:700},
    {name:'Badgers',family:'BADGERS, sans-serif',weight:700},
    {name:'Bison',family:'BISON, sans-serif',weight:700},
    {name:'Bulldog Bold',family:'BULLDOG_BOLD, sans-serif',weight:700},
    {name:'Cal Mustangs',family:'CAL_MUSTANGS, sans-serif',weight:700},
    {name:'Cards',family:'CARDS, sans-serif',weight:700},
    {name:'Cougars',family:'COUGARS, sans-serif',weight:700},
    {name:'Cyclone',family:'CYCLONE, sans-serif',weight:700},
    {name:'Gator Script',family:'GATOR_SCRIPT, cursive',weight:400, mixedCase:true}
  ];

  // Mascots - each loads its SVG from theme assets.
  // To add a new mascot:
  //   1. Upload mascot-{id}.svg to theme assets (single-color, transparent background)
  //   2. Add data-mascot-{id}="{{ 'mascot-{id}.svg' | asset_url }}" to the snippet
  //   3. Add an entry below: {id:'foo', name:'Foo'}
  var MASCOTS = [
    {id:'buffalo', name:'Buffalo'},
    {id:'bison', name:'Bison'}
  ];

  // Cache for loaded mascot SVG text
  var loadedMascotSVGs = {};

  function loadMascotSVG(mascotId) {
    if (!mascotId) return Promise.resolve(null);
    if (loadedMascotSVGs[mascotId]) return Promise.resolve(loadedMascotSVGs[mascotId]);
    function camelize(str) {
      return str.split('-').map(function(p, i){
        return i === 0 ? p : p.charAt(0).toUpperCase() + p.slice(1);
      }).join('');
    }
    var dataKey = 'mascot' + camelize(mascotId).charAt(0).toUpperCase() + camelize(mascotId).slice(1);
    var url = ROOT.dataset[dataKey];
    if (!url) return Promise.reject(new Error('No URL for mascot: ' + mascotId));
    return fetch(url).then(function(r){
      if (!r.ok) throw new Error('Mascot SVG load failed: ' + url);
      return r.text();
    }).then(function(text){
      loadedMascotSVGs[mascotId] = text;
      return text;
    });
  }

  // Find a MASCOT_COLOR_n layer in the SVG. Illustrator URL-encodes IDs that
  // contain # or _ chars, so #MASCOT_COLOR_1 becomes _x23_MASCOT_x5F_COLOR_x5F_1
  // when exported. We check for both forms.
  function findMascotColorLayer(svgEl, n) {
    var candidates = [
      '_MASCOT_COLOR_' + n,
      'MASCOT_COLOR_' + n,
      '_x23_MASCOT_x5F_COLOR_x5F_' + n,
      'MASCOT_x5F_COLOR_x5F_' + n
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = svgEl.querySelector('#' + candidates[i]);
      if (el) return el;
    }
    return null;
  }

  // Count how many MASCOT_COLOR_n layers a mascot SVG has
  function countMascotColors(svgText) {
    if (!svgText) return 0;
    var max = 0;
    for (var n = 1; n <= 5; n++) {
      // Match either #MASCOT_COLOR_n or the URL-encoded version
      var pattern = new RegExp('id="(_?MASCOT_COLOR_' + n + '|_x23_MASCOT_x5F_COLOR_x5F_' + n + ')"');
      if (pattern.test(svgText)) max = n;
    }
    return max;
  }

  // Stripes - simple stripes use one SVG for both views.
  // Stripes with perView:true use stripe-{id}-front.svg and stripe-{id}-back.svg
  var STRIPES = [
    {id:'none', name:'None'},
    {id:'single1', name:'Single 1"'},
    {id:'state', name:'State'},
    {id:'bronco-front', name:'Bronco Front Start', perView: true},
    {id:'bronco-back', name:'Bronco Back Start', perView: true}
  ];

  // Loaded stripe SVG text - keyed by id OR by id+'-front'/'-back' for perView stripes
  var loadedStripeSVGs = {};

  function loadStripeSVG(stripeId, view) {
    if (stripeId === 'none') return Promise.resolve(null);
    var def = STRIPES.find(function(s){return s.id === stripeId;});
    if (!def) return Promise.resolve(null);

    // Build dataset key: 'stripe' + camelCased stripeId (+ camelCased view for perView)
    // 'bronco-front' -> 'broncoFront'; with view 'front' -> dataset.stripeBroncoFrontFront
    function camelize(str) {
      return str.split('-').map(function(p, i){
        return i === 0 ? p : p.charAt(0).toUpperCase() + p.slice(1);
      }).join('');
    }
    var cacheKey = stripeId;
    var dataKey = 'stripe' + camelize(stripeId).charAt(0).toUpperCase() + camelize(stripeId).slice(1);
    if (def.perView && view) {
      cacheKey = stripeId + '-' + view;
      dataKey = dataKey + (view === 'front' ? 'Front' : 'Back');
    }
    if (loadedStripeSVGs[cacheKey]) return Promise.resolve(loadedStripeSVGs[cacheKey]);
    var url = ROOT.dataset[dataKey];
    if (!url) return Promise.reject(new Error('No URL for stripe asset: ' + dataKey));
    return fetch(url).then(function(r){
      if (!r.ok) throw new Error('Stripe SVG load failed: ' + url);
      return r.text();
    }).then(function(text){
      loadedStripeSVGs[cacheKey] = text;
      return text;
    });
  }

  // Count how many #STRIPE_COLOR_n layers a stripe SVG has
  function countStripeColors(svgText) {
    if (!svgText) return 0;
    var matches = svgText.match(/id="_?STRIPE_COLOR_\d+"/g);
    return matches ? matches.length : 0;
  }

  // ============================================================
  // STATE
  // ============================================================
  // Shared (applies to all views)
  var state = {
    shellColor:'#FFFFFF', shellName:'White', shellMetallic:false,
    maskColor:'#0A0A0A', maskName:'Black',
    activeView: 'right',
    mirrorSides: true,
    mirrorSource: 'right', // 'left' or 'right' - whichever was last edited
    mirrorDecalFlip: true, // when sides match, flip the mirrored side horizontally so decals face forward
    // Per-view decals
    decals: {
      right: { mode:'mascot', mascotId:null, letterText:'', letterFont:FONTS[0].name, letterFontFamily:FONTS[0].family, letterFontWeight:FONTS[0].weight, color:'#0A0A0A', colorName:'Black', color2:'#FFFFFF', color2Name:'White', color3:'#888888', color3Name:'Gray', letterColor:'#FFFFFF', letterColorName:'White', letterOutline:false, letterOutlineColor:'#0A0A0A', letterOutlineColorName:'Black', uploadDataUrl:null, uploadName:'', size:60, offsetX:0, offsetY:0 },
      left:  { mode:'mascot', mascotId:null, letterText:'', letterFont:FONTS[0].name, letterFontFamily:FONTS[0].family, letterFontWeight:FONTS[0].weight, color:'#0A0A0A', colorName:'Black', color2:'#FFFFFF', color2Name:'White', color3:'#888888', color3Name:'Gray', letterColor:'#FFFFFF', letterColorName:'White', letterOutline:false, letterOutlineColor:'#0A0A0A', letterOutlineColorName:'Black', uploadDataUrl:null, uploadName:'', size:60, offsetX:0, offsetY:0 }
    },
    // Per-view stripes (front/back)
    // Stripes: shared style + colors across front/back. Some stripes have per-view variants.
    stripe: { id:'none', color1:'#FFFFFF', color1Name:'White', color2:'#1A1A1A', color2Name:'Black', color3:'#888888', color3Name:'Gray' },
    // Customer info captured before first download/share/email. Persists for session.
    customer: { teamName:'', contactName:'', email:'', phone:'', captured:false }
  };

  // SVG storage per view
  var loadedSVGs = { left:null, right:null, front:null, back:null };

  var ROOT = document.querySelector('.helmet-config');
  if (!ROOT) return;

  function $(s){return ROOT.querySelector(s);}
  function $$(s){return ROOT.querySelectorAll(s);}

  function showToast(msg) {
    var t = document.getElementById('hc-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    setTimeout(function(){t.classList.remove('show');}, 2800);
  }

  function escapeHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  function isSide(view) { return view === 'left' || view === 'right'; }
  function isStripe(view) { return view === 'front' || view === 'back'; }

  // Returns the view whose data should be EDITED when the user interacts with controls
  // - If side view + mirror ON: source side is edited (mirror reflects to other)
  // - If side view + mirror OFF: that view's data
  // - If front/back: that view's data
  function getEditingView() {
    if (isSide(state.activeView) && state.mirrorSides) {
      return state.mirrorSource;
    }
    return state.activeView;
  }

  // Mark the currently-active side as the new mirror source
  // (called when the user starts editing a side view)
  function markActiveAsSource() {
    if (isSide(state.activeView) && state.mirrorSides) {
      state.mirrorSource = state.activeView;
    }
  }

  // ============================================================
  // SVG LOAD - all 4 in parallel
  // ============================================================
  function loadAllSVGs() {
    var views = ['left','right','front','back'];
    var promises = views.map(function(view){
      var url = ROOT.dataset['svg' + view.charAt(0).toUpperCase() + view.slice(1)];
      return fetch(url).then(function(r){return r.text();}).then(function(text){
        var parser = new DOMParser();
        var doc = parser.parseFromString(text, 'image/svg+xml');
        var svg = doc.querySelector('svg');
        if (!svg) throw new Error('No SVG in ' + view);
        svg.classList.add('hc-helmet-base');
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        // Give each layer a view-specific class so we can scope selectors
        svg.setAttribute('data-view', view);
        var placeholder = ROOT.querySelector('[data-helmet-view="' + view + '"]');
        if (placeholder) placeholder.replaceWith(svg);
        loadedSVGs[view] = svg;
      });
    });
    return Promise.all(promises);
  }

  // ============================================================
  // RECOLOR
  // ============================================================
  function recolorGroup(svgEl, groupId, color) {
    if (!svgEl) return;
    var g = svgEl.querySelector('#' + groupId);
    if (!g) return;
    if (g.tagName.toLowerCase() !== 'g') {
      if (g.getAttribute('fill') && g.getAttribute('fill') !== 'none') g.setAttribute('fill', color);
      else if (g.getAttribute('stroke') && g.getAttribute('stroke') !== 'none') g.setAttribute('stroke', color);
      return;
    }
    g.querySelectorAll('path, line, polyline, polygon, rect, circle, ellipse').forEach(function(el){
      var hasFill = el.getAttribute('fill') && el.getAttribute('fill') !== 'none';
      var hasStroke = el.getAttribute('stroke') && el.getAttribute('stroke') !== 'none';
      if (hasFill) el.setAttribute('fill', color);
      else if (hasStroke) el.setAttribute('stroke', color);
      else el.setAttribute('fill', color);
    });
  }

  // Inject (or update) a metallic gradient definition into the helmet SVG,
  // then apply it to the _HELMET_COLOR group. Removes any existing gradient
  // first so switching between solid <-> metallic <-> different metallic works.
  function applyMetallicShell(svgEl, hex) {
    if (!svgEl) return;
    var gradId = '_gds_metal_shell';
    // Remove existing defs/gradient if present
    var existingDefs = svgEl.querySelector('#_gds_metal_defs');
    if (existingDefs) existingDefs.parentNode.removeChild(existingDefs);

    // Build a linearGradient that matches the colors.html visual treatment:
    // lighter (+60) at 0%, base at 40%, darker (-30) at 70%, lighter at 100%
    var r = parseInt(hex.slice(1,3),16);
    var g = parseInt(hex.slice(3,5),16);
    var b = parseInt(hex.slice(5,7),16);
    function clamp(v){ return Math.max(0, Math.min(255, v)); }
    var lighter = 'rgb(' + clamp(r+60) + ',' + clamp(g+60) + ',' + clamp(b+60) + ')';
    var darker = 'rgb(' + clamp(r-30) + ',' + clamp(g-30) + ',' + clamp(b-30) + ')';

    var svgNS = 'http://www.w3.org/2000/svg';
    var defs = document.createElementNS(svgNS, 'defs');
    defs.setAttribute('id', '_gds_metal_defs');
    var grad = document.createElementNS(svgNS, 'linearGradient');
    grad.setAttribute('id', gradId);
    grad.setAttribute('x1', '0%');
    grad.setAttribute('y1', '0%');
    grad.setAttribute('x2', '100%');
    grad.setAttribute('y2', '100%');
    var stops = [
      { offset: '0%', color: lighter },
      { offset: '40%', color: hex },
      { offset: '70%', color: darker },
      { offset: '100%', color: lighter }
    ];
    stops.forEach(function(s){
      var stop = document.createElementNS(svgNS, 'stop');
      stop.setAttribute('offset', s.offset);
      stop.setAttribute('stop-color', s.color);
      grad.appendChild(stop);
    });
    defs.appendChild(grad);
    // Insert defs as first child of svg
    svgEl.insertBefore(defs, svgEl.firstChild);

    // Apply gradient reference to all shapes in _HELMET_COLOR group
    var helmetGroup = svgEl.querySelector('#_HELMET_COLOR');
    if (!helmetGroup) return;
    helmetGroup.querySelectorAll('path, line, polyline, polygon, rect, circle, ellipse').forEach(function(el){
      var hasFill = el.getAttribute('fill') && el.getAttribute('fill') !== 'none';
      var hasStroke = el.getAttribute('stroke') && el.getAttribute('stroke') !== 'none';
      if (hasFill) el.setAttribute('fill', 'url(#' + gradId + ')');
      else if (hasStroke) el.setAttribute('stroke', 'url(#' + gradId + ')');
      else el.setAttribute('fill', 'url(#' + gradId + ')');
    });
  }

  // Clean up any previously-applied metallic gradient (when switching back to solid)
  function clearMetallicShell(svgEl) {
    if (!svgEl) return;
    var defs = svgEl.querySelector('#_gds_metal_defs');
    if (defs) defs.parentNode.removeChild(defs);
  }

  function applyHelmetToAll() {
    ['left','right','front','back'].forEach(function(view){
      var svg = loadedSVGs[view];
      if (!svg) return;
      if (state.shellMetallic) {
        // Metallic: build gradient and apply
        applyMetallicShell(svg, state.shellColor);
      } else {
        // Solid: ensure any old metallic gradient is gone, then recolor normally
        clearMetallicShell(svg);
        recolorGroup(svg, '_HELMET_COLOR', state.shellColor);
      }
      recolorGroup(svg, '_FACEMASK', state.maskColor);
    });
  }

  // ============================================================
  // DECAL - per view (right and left only)
  // ============================================================
  function getEffectiveDecal(view) {
    // If side view + mirroring + this isn't the source: return source's data
    if (isSide(view) && state.mirrorSides && view !== state.mirrorSource) {
      return state.decals[state.mirrorSource];
    }
    return state.decals[view];
  }

  function getDecalGeometry(view) {
    var svg = loadedSVGs[view];
    if (!svg) return null;
    var zoneGroup = svg.querySelector('#_DECAL_ZONE');
    if (!zoneGroup) return null;
    var vb = svg.getAttribute('viewBox').split(/\s+/).map(parseFloat);
    var vbW = vb[2], vbH = vb[3];
    var zx, zy, zw, zh;
    var zoneRect = zoneGroup.querySelector('rect');
    if (zoneRect) {
      zx = parseFloat(zoneRect.getAttribute('x')) || 0;
      zy = parseFloat(zoneRect.getAttribute('y')) || 0;
      zw = parseFloat(zoneRect.getAttribute('width')) || 0;
      zh = parseFloat(zoneRect.getAttribute('height')) || 0;
    } else {
      try {
        var bbox = zoneGroup.getBBox();
        zx = bbox.x; zy = bbox.y; zw = bbox.width; zh = bbox.height;
      } catch (e) { return null; }
    }
    var d = getEffectiveDecal(view);
    var baseSize = Math.max(zw, zh) * 1.4;
    var sizeFactor = d.size / 100;
    var sw = baseSize * sizeFactor;
    var sh = baseSize * sizeFactor;
    // If this view is the MIRRORED side (not the source), flip horizontal offset
    var offsetX = d.offsetX;
    var isMirrored = false;
    if (isSide(view) && state.mirrorSides && view !== state.mirrorSource) {
      offsetX = -d.offsetX;
      isMirrored = true;
    }
    var offsetXpx = (offsetX / 100) * vbW;
    var offsetYpx = (d.offsetY / 100) * vbH;
    var cx = zx + zw/2 + offsetXpx;
    var cy = zy + zh/2 + offsetYpx;
    return {svg:svg, vbW:vbW, vbH:vbH, cx:cx, cy:cy, sw:sw, sh:sh, isMirrored:isMirrored};
  }

  function applyDecalToView(view) {
    if (!isSide(view)) return;
    var geo = getDecalGeometry(view);
    if (!geo) return;
    var svg = geo.svg;
    var existing = svg.querySelector('#_GDS_DECAL_LAYER');
    if (existing) existing.remove();

    var d = getEffectiveDecal(view);
    var hasContent = false;
    var inner = '';

    if (d.mode === 'mascot' && d.mascotId) {
      var m = null;
      for (var i = 0; i < MASCOTS.length; i++) { if (MASCOTS[i].id === d.mascotId) { m = MASCOTS[i]; break; } }
      if (m) {
        hasContent = true;
        // Mascots load asynchronously - render placeholder, then swap in real paths
        // when SVG arrives. The placeholder is invisible so there's no flash.
        loadMascotSVG(d.mascotId).then(function(svgText){
          var current = getEffectiveDecal(view);
          if (current.mode !== 'mascot' || current.mascotId !== d.mascotId) return;
          renderMascotSVG(view, svgText, current);
        }).catch(function(err){
          console.warn('[GDS] Mascot SVG load failed:', err);
        });
        // Initial inner is empty; renderMascotSVG injects paths after fetch
        inner = '';
      }
    } else if (d.mode === 'lettering' && d.letterText) {
      hasContent = true;
      // Scale font down for longer words. A 4-letter word at full size,
      // longer words progressively scaled to keep within the decal frame width.
      var textLen = d.letterText.length;
      var scaleFactor = textLen > 4 ? (4 / textLen) : 1;
      var fontSize = geo.sh * 0.55 * scaleFactor;
      // Look up the font to check if it's a mixed-case font (script/cursive)
      // Block fonts force uppercase. Script fonts preserve as-typed.
      var fontDef = FONTS.find(function(f){return f.name === d.letterFont;});
      var displayText = (fontDef && fontDef.mixedCase) ? d.letterText : d.letterText.toUpperCase();
      // Build text element with optional outline stroke. paint-order=stroke ensures
      // the outline renders BEHIND the fill (so stroke doesn't eat into letter shapes).
      var strokeAttrs = '';
      if (d.letterOutline) {
        var strokeWidth = fontSize * 0.06; // 6% of font size = balanced outline thickness
        strokeAttrs = ' stroke="'+d.letterOutlineColor+'" stroke-width="'+strokeWidth+'" stroke-linejoin="round" paint-order="stroke fill"';
      }
      inner = '<text x="'+geo.cx+'" y="'+(geo.cy + geo.sh*0.15)+'" text-anchor="middle" font-family="'+d.letterFontFamily+'" font-weight="'+d.letterFontWeight+'" font-size="'+fontSize+'" letter-spacing="'+(geo.sh*0.025*scaleFactor)+'" fill="'+d.letterColor+'"'+strokeAttrs+'>'+escapeHtml(displayText)+'</text>';
    } else if (d.mode === 'upload' && d.uploadDataUrl) {
      hasContent = true;
      inner = '<image x="'+(geo.cx - geo.sw/2)+'" y="'+(geo.cy - geo.sh/2)+'" width="'+geo.sw+'" height="'+geo.sh+'" href="'+d.uploadDataUrl+'" preserveAspectRatio="xMidYMid meet"/>';
    }

    if (hasContent) {
      var parser = new DOMParser();
      // Build the wrapper. If this view is the mirrored side AND mirrorDecalFlip is on,
      // flip the decal horizontally around its center (geo.cx) so it faces forward.
      var transformAttr = '';
      if (geo.isMirrored && state.mirrorDecalFlip) {
        // scale(-1, 1) flips horizontally, but we need to flip around cx so the decal
        // stays in the same position. Translate by 2*cx, then scale.
        transformAttr = ' transform="translate(' + (2 * geo.cx) + ' 0) scale(-1 1)"';
      }
      var tmp = parser.parseFromString('<svg xmlns="http://www.w3.org/2000/svg"><g id="_GDS_DECAL_LAYER"'+transformAttr+' style="pointer-events:none;">'+inner+'</g></svg>', 'image/svg+xml');
      var decalNode = tmp.querySelector('#_GDS_DECAL_LAYER');
      var children = svg.children;
      var blockers = ['_DECAL_ZONE','_FACEMASK','_HARDWARE'];
      var firstBlocker = null;
      for (var j = 0; j < children.length; j++) {
        if (blockers.indexOf(children[j].id) !== -1) { firstBlocker = children[j]; break; }
      }
      if (firstBlocker) firstBlocker.parentNode.insertBefore(decalNode, firstBlocker);
      else svg.appendChild(decalNode);
    }
  }

  // Render dynamic 1-3 color pickers for the currently selected mascot.
  // Count of pickers depends on how many MASCOT_COLOR_n layers the mascot SVG has.
  function renderMascotColors() {
    var wrap = document.getElementById('hc-mascot-colors');
    if (!wrap) return;
    var view = getEditingView();
    var d = state.decals[view];
    if (d.mode !== 'mascot' || !d.mascotId) {
      wrap.innerHTML = '';
      return;
    }
    loadMascotSVG(d.mascotId).then(function(text){
      var count = countMascotColors(text);
      // If the SVG has no labeled MASCOT_COLOR layers, default to 1 (recolor whole thing)
      if (count === 0) count = 1;
      var slots = [
        { key: 'color', nameKey: 'colorName', label: 'Color 1' },
        { key: 'color2', nameKey: 'color2Name', label: 'Color 2' },
        { key: 'color3', nameKey: 'color3Name', label: 'Color 3' }
      ];
      var html = '';
      for (var i = 0; i < count && i < 3; i++) {
        var slot = slots[i];
        html += '<span class="hc-label">' + slot.label + '</span>' +
                '<div class="hc-swatches" data-target="mascot-' + slot.key + '"></div>' +
                '<div class="hc-selected"><span class="hc-selected-label">Selected:</span>' +
                '<span data-selected-label="mascot-' + slot.key + '">'+escapeHtml(d[slot.nameKey] || '')+'</span></div>';
      }
      wrap.innerHTML = html;
      for (var j = 0; j < count && j < 3; j++) {
        (function(idx){
          var slot = slots[idx];
          renderPalette('mascot-' + slot.key, d[slot.key], function(c, n){
            var v = getEditingView();
            state.decals[v][slot.key] = c;
            state.decals[v][slot.nameKey] = n;
            applyAllDecals();
            updateSummary();
          }, getDecalPalette());
        })(j);
      }
    }).catch(function(err){
      console.warn(err);
      wrap.innerHTML = '<div class="hc-helper-text">Could not load mascot colors.</div>';
    });
  }

  // Async-load and inject a mascot SVG into the decal layer of a view.
  // Recolors each #MASCOT_COLOR_n layer with the matching color from state.
  // Scales to fit the decal box.
  function renderMascotSVG(view, svgText, decal) {
    var svg = loadedSVGs[view];
    if (!svg) return;
    var decalLayer = svg.querySelector('#_GDS_DECAL_LAYER');
    if (!decalLayer) return;
    var geo = getDecalGeometry(view);
    if (!geo) return;

    var parser = new DOMParser();
    var doc = parser.parseFromString(svgText, 'image/svg+xml');
    var mascotSvg = doc.querySelector('svg');
    if (!mascotSvg) return;

    var sVb = mascotSvg.getAttribute('viewBox');
    var sVbW, sVbH;
    if (sVb) {
      var arr = sVb.split(/\s+/).map(parseFloat);
      sVbW = arr[2]; sVbH = arr[3];
    } else {
      sVbW = parseFloat(mascotSvg.getAttribute('width')) || 100;
      sVbH = parseFloat(mascotSvg.getAttribute('height')) || 100;
    }

    // Recolor each #MASCOT_COLOR_n layer. Color slot mapping:
    //   COLOR_1 -> decal.color
    //   COLOR_2 -> decal.color2
    //   COLOR_3 -> decal.color3
    var colorMap = [
      { layer: 1, color: decal.color },
      { layer: 2, color: decal.color2 || '#FFFFFF' },
      { layer: 3, color: decal.color3 || '#888888' }
    ];
    colorMap.forEach(function(slot){
      var layer = findMascotColorLayer(mascotSvg, slot.layer);
      if (!layer) return;
      // Recolor all shapes inside the layer
      layer.querySelectorAll('path, polygon, polyline, rect, circle, ellipse, line').forEach(function(el){
        var currentFill = el.getAttribute('fill');
        // Always set fill - overwrite "none", missing, or any other color
        if (currentFill !== 'none') {
          el.setAttribute('fill', slot.color);
        }
        var currentStroke = el.getAttribute('stroke');
        if (currentStroke && currentStroke !== 'none') {
          el.setAttribute('stroke', slot.color);
        }
      });
      // Also handle the case where the layer itself has no fill children but
      // shapes that should be colored. Apply fill to shapes that have no fill attr.
      layer.querySelectorAll('path, polygon, polyline, rect, circle, ellipse').forEach(function(el){
        if (!el.hasAttribute('fill')) {
          el.setAttribute('fill', slot.color);
        }
      });
    });

    // Scale uniformly to preserve aspect ratio
    var scale = Math.min(geo.sw / sVbW, geo.sh / sVbH);
    var actualW = sVbW * scale;
    var actualH = sVbH * scale;
    var translateX = geo.cx - actualW / 2;
    var translateY = geo.cy - actualH / 2;

    while (decalLayer.firstChild) decalLayer.removeChild(decalLayer.firstChild);

    var wrapperG = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    wrapperG.setAttribute('transform', 'translate(' + translateX + ' ' + translateY + ') scale(' + scale + ')');

    Array.from(mascotSvg.children).forEach(function(child){
      wrapperG.appendChild(document.importNode(child, true));
    });

    decalLayer.appendChild(wrapperG);
  }

  function applyAllDecals() {
    applyDecalToView('right');
    applyDecalToView('left');
  }

  function updateDecalPositionInPlace(view) {
    var geo = getDecalGeometry(view);
    if (!geo) return;
    var decalLayer = geo.svg.querySelector('#_GDS_DECAL_LAYER');
    if (decalLayer) {
      var d = getEffectiveDecal(view);
      var text = decalLayer.querySelector('text');
      var image = decalLayer.querySelector('image');
      if (text) {
        text.setAttribute('x', geo.cx);
        text.setAttribute('y', geo.cy + geo.sh * (d.mode === 'mascot' ? 0.18 : 0.15));
      }
      if (image) {
        image.setAttribute('x', geo.cx - geo.sw/2);
        image.setAttribute('y', geo.cy - geo.sh/2);
      }
    }
  }

  // ============================================================
  // STRIPES - per view (front/back only)
  // ============================================================
  function applyStripeToView(view) {
    if (!isStripe(view)) return;
    var svg = loadedSVGs[view];
    if (!svg) return;
    var existing = svg.querySelector('#_GDS_STRIPE_LAYER');
    if (existing) existing.remove();

    var s = state.stripe;
    if (s.id === 'none') return;

    // Stripe zone: prefer #STRIPE_ZONE, fall back to #DECAL_ZONE
    var zoneGroup = svg.querySelector('#_STRIPE_ZONE') || svg.querySelector('#_DECAL_ZONE');
    var vb = svg.getAttribute('viewBox').split(/\s+/).map(parseFloat);
    var vbW = vb[2], vbH = vb[3];
    var zx, zy, zw, zh;
    if (zoneGroup) {
      // Try <rect> first (simple case)
      var zoneRect = zoneGroup.querySelector('rect');
      if (zoneRect) {
        zx = parseFloat(zoneRect.getAttribute('x')) || 0;
        zy = parseFloat(zoneRect.getAttribute('y')) || 0;
        zw = parseFloat(zoneRect.getAttribute('width')) || 0;
        zh = parseFloat(zoneRect.getAttribute('height')) || 0;
      } else {
        // Path or other shape - use getBBox to compute bounding box
        try {
          var bbox = zoneGroup.getBBox();
          zx = bbox.x; zy = bbox.y; zw = bbox.width; zh = bbox.height;
        } catch (e) {
          zx = vbW * 0.4; zy = vbH * 0.1; zw = vbW * 0.2; zh = vbH * 0.8;
        }
      }
    } else {
      zx = vbW * 0.4; zy = vbH * 0.1; zw = vbW * 0.2; zh = vbH * 0.8;
    }

    // Load stripe SVG (passes view so per-view stripes get the right variant) and inject
    loadStripeSVG(s.id, view).then(function(stripeText){
      if (!stripeText) return;
      if (state.stripe.id !== s.id) return;
      var parser = new DOMParser();
      var doc = parser.parseFromString(stripeText, 'image/svg+xml');
      var stripeSvg = doc.querySelector('svg');
      if (!stripeSvg) return;

      var sVb = stripeSvg.getAttribute('viewBox');
      if (!sVb) return;
      var sVbArr = sVb.split(/\s+/).map(parseFloat);
      var sVbW = sVbArr[2], sVbH = sVbArr[3];

      // Scale stripe to fit decal zone WIDTH, preserve aspect ratio, anchor to TOP.
      // This means stripes shorter than the full decal zone (like bronco front piece)
      // will appear as the correct physical proportion on the helmet.
      var scale = zw / sVbW;
      var transform = 'translate(' + zx + ' ' + zy + ') scale(' + scale + ')';

      // Apply current colors to the stripe SVG's color layers
      var current = state.stripe;
      var colorMap = {
        '_STRIPE_COLOR_1': current.color1,
        '_STRIPE_COLOR_2': current.color2,
        '_STRIPE_COLOR_3': current.color3
      };
      Object.keys(colorMap).forEach(function(key){
        var layer = stripeSvg.querySelector('#' + key);
        if (!layer) return;
        var color = colorMap[key];
        layer.querySelectorAll('path, line, polyline, polygon, rect, circle, ellipse').forEach(function(el){
          var hasFill = el.getAttribute('fill') && el.getAttribute('fill') !== 'none';
          var hasStroke = el.getAttribute('stroke') && el.getAttribute('stroke') !== 'none';
          if (hasFill) el.setAttribute('fill', color);
          else if (hasStroke) el.setAttribute('stroke', color);
          else el.setAttribute('fill', color);
        });
      });

      // Wrap into a group with transform and inject into helmet SVG
      var wrapperG = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      wrapperG.setAttribute('id', '_GDS_STRIPE_LAYER');
      wrapperG.setAttribute('transform', transform);
      wrapperG.style.pointerEvents = 'none';
      Array.from(stripeSvg.children).forEach(function(child){
        wrapperG.appendChild(document.importNode(child, true));
      });

      // Insert before blockers so facemask + hardware render on top
      var children = svg.children;
      var blockers = ['_STRIPE_ZONE','_DECAL_ZONE','_FACEMASK','_HARDWARE'];
      var firstBlocker = null;
      for (var j = 0; j < children.length; j++) {
        if (blockers.indexOf(children[j].id) !== -1) { firstBlocker = children[j]; break; }
      }
      if (firstBlocker) firstBlocker.parentNode.insertBefore(wrapperG, firstBlocker);
      else svg.appendChild(wrapperG);
    }).catch(function(err){
      console.error('Stripe load failed:', err);
    });
  }

  function applyAllStripes() {
    applyStripeToView('front');
    applyStripeToView('back');
  }

  // ============================================================
  // DRAG - works on the active view
  // ============================================================
  function setupDrag() {
    var views = ['left','right'];
    views.forEach(function(view){
      var wrap = ROOT.querySelector('[data-helmet-wrap="' + view + '"]');
      if (!wrap) return;

      var dragging = false;
      var startX = 0, startY = 0;
      var startOffsetX = 0, startOffsetY = 0;

      wrap.style.userSelect = 'none';
      wrap.style.touchAction = 'pan-y';

      function isPointOnDecal(clientX, clientY) {
        // Only drag on the currently active side
        if (view !== state.activeView) return false;
        var geo = getDecalGeometry(view);
        if (!geo || !geo.svg) return false;
        var d = getEffectiveDecal(view);
        var hasDecal = (d.mode === 'mascot' && d.mascotId) ||
                       (d.mode === 'lettering' && d.letterText) ||
                       (d.mode === 'upload' && d.uploadDataUrl);
        if (!hasDecal) return false;
        var svgRect = geo.svg.getBoundingClientRect();
        var scaleX = svgRect.width / geo.vbW;
        var scaleY = svgRect.height / geo.vbH;
        var localX = (clientX - svgRect.left) / scaleX;
        var localY = (clientY - svgRect.top) / scaleY;
        var pad = geo.sw * 0.1;
        return (localX >= geo.cx - geo.sw/2 - pad &&
                localX <= geo.cx + geo.sw/2 + pad &&
                localY >= geo.cy - geo.sh/2 - pad &&
                localY <= geo.cy + geo.sh/2 + pad);
      }

      function startDrag(x, y, e) {
        if (!isPointOnDecal(x, y)) return;
        dragging = true;
        wrap.style.cursor = 'grabbing';
        startX = x; startY = y;
        // Mark active side as new source if mirroring
        markActiveAsSource();
        // Edit this view's data (it's the source if mirroring)
        var d = state.decals[view];
        startOffsetX = d.offsetX;
        startOffsetY = d.offsetY;
        if (e && e.cancelable) e.preventDefault();
      }

      function onMove(x, y) {
        if (!dragging) {
          wrap.style.cursor = isPointOnDecal(x, y) ? 'grab' : 'default';
          return;
        }
        var rect = wrap.getBoundingClientRect();
        var dxPct = ((x - startX) / rect.width) * 100;
        var dyPct = ((y - startY) / rect.height) * 100;
        var d = state.decals[view];
        d.offsetX = Math.max(-60, Math.min(60, startOffsetX + dxPct));
        d.offsetY = Math.max(-60, Math.min(60, startOffsetY + dyPct));
        // Update both sides if mirroring
        if (state.mirrorSides) {
          updateDecalPositionInPlace('right');
          updateDecalPositionInPlace('left');
        } else {
          updateDecalPositionInPlace(view);
        }
      }

      function endDrag() {
        if (dragging) {
          dragging = false;
          wrap.style.cursor = 'default';
        }
      }

      wrap.addEventListener('mousedown', function(e){ startDrag(e.clientX, e.clientY, e); });
      document.addEventListener('mousemove', function(e){ onMove(e.clientX, e.clientY); });
      document.addEventListener('mouseup', endDrag);

      wrap.addEventListener('touchstart', function(e){
        if (e.touches.length === 1 && isPointOnDecal(e.touches[0].clientX, e.touches[0].clientY)) {
          e.preventDefault();
          startDrag(e.touches[0].clientX, e.touches[0].clientY, e);
        }
      }, {passive:false});
      document.addEventListener('touchmove', function(e){
        if (dragging && e.touches.length === 1) {
          e.preventDefault();
          onMove(e.touches[0].clientX, e.touches[0].clientY);
        }
      }, {passive:false});
      document.addEventListener('touchend', endDrag);
      document.addEventListener('touchcancel', endDrag);
    });
  }

  // ============================================================
  // VIEW SWITCHING
  // ============================================================
  function setActiveView(view) {
    state.activeView = view;
    $$('.hc-view').forEach(function(v){
      v.classList.toggle('hc-view-active', v.dataset.view === view);
    });
    // Update controls panel tag
    var tag = document.getElementById('hc-active-view-tag');
    if (tag) {
      var labels = {left:'Left Side', right:'Right Side', front:'Front', back:'Rear'};
      tag.textContent = labels[view];
    }
    // Show appropriate controls
    var showSide = isSide(view);
    var showStripe = isStripe(view);
    $$('.hc-view-only--side').forEach(function(el){
      el.style.display = showSide ? 'block' : 'none';
    });
    $$('.hc-view-only--stripe').forEach(function(el){
      el.style.display = showStripe ? 'block' : 'none';
    });
    // Mirror toggle visibility - show on any side view
    var mirrorWrap = document.getElementById('hc-mirror-toggle-wrap');
    if (mirrorWrap) mirrorWrap.style.display = isSide(view) ? 'block' : 'none';
    // Mirror flip toggle only relevant when sides match is on
    var mirrorFlipWrap = document.getElementById('hc-mirror-flip-wrap');
    if (mirrorFlipWrap) mirrorFlipWrap.style.display = (isSide(view) && state.mirrorSides) ? 'block' : 'none';
    // Decal controls always visible on side views
    var decalControls = document.getElementById('hc-decal-controls');
    if (decalControls) {
      decalControls.style.display = isSide(view) ? 'block' : 'none';
    }
    // When user clicks a side view, that becomes the new mirror source
    if (isSide(view) && state.mirrorSides) {
      state.mirrorSource = view;
      // Re-apply decals so the mirrored side updates
      applyAllDecals();
    }
    // Re-render with the current view's decal/stripe values
    refreshControlsForCurrentView();
  }

  function refreshControlsForCurrentView() {
    var view = state.activeView;
    if (isSide(view)) {
      var d = state.decals[getEditingView()];
      // Set tab
      $$('.hc-tab').forEach(function(t){
        t.setAttribute('aria-selected', t.dataset.tab === d.mode ? 'true' : 'false');
      });
      $$('.hc-tab-panel').forEach(function(p){
        p.hidden = p.dataset.panel !== d.mode;
      });
      // Letter input
      var letterInput = document.getElementById('hc-letter-input');
      if (letterInput) letterInput.value = d.letterText;
      // Outline toggle + controls
      var outlineToggle2 = document.getElementById('hc-letter-outline-toggle');
      var outlineControls2 = document.getElementById('hc-letter-outline-controls');
      if (outlineToggle2) outlineToggle2.checked = !!d.letterOutline;
      if (outlineControls2) outlineControls2.style.display = d.letterOutline ? 'block' : 'none';
      var outlineLbl = ROOT.querySelector('[data-selected-label="letter-outline-color"]');
      if (outlineLbl) outlineLbl.textContent = d.letterOutlineColorName || 'Black';
      // Size slider
      var sizeSlider = document.getElementById('hc-decal-size');
      var sizeVal = document.getElementById('hc-decal-size-val');
      if (sizeSlider) sizeSlider.value = d.size;
      if (sizeVal) sizeVal.textContent = d.size + '%';
      // Refresh mascot picker (active state) and color pickers
      renderMascots();
      renderMascotColors();
    }
    if (isStripe(view)) {
      renderStripeControls();
    }
  }

  // ============================================================
  // RENDERS
  // ============================================================
  function renderPalette(target, selectedHex, onPick, customPalette) {
    var palette = customPalette || PALETTE;
    var wrap = ROOT.querySelector('[data-target="' + target + '"]');
    if (!wrap) return;
    wrap.innerHTML = '';
    palette.forEach(function(c){
      var sw = document.createElement('button');
      sw.type = 'button';
      sw.className = 'hc-swatch' + (c.metallic ? ' hc-swatch--metallic' : '');
      sw.style.background = c.metallic ? metalGradient(c.hex) : c.hex;
      sw.setAttribute('aria-pressed', c.hex.toUpperCase() === selectedHex.toUpperCase() ? 'true' : 'false');
      sw.setAttribute('aria-label', c.name);
      sw.innerHTML = '<span class="hc-swatch-name">'+escapeHtml(c.name)+'</span>';
      sw.addEventListener('click', function(){
        wrap.querySelectorAll('.hc-swatch').forEach(function(x){x.setAttribute('aria-pressed','false');});
        sw.setAttribute('aria-pressed','true');
        var label = ROOT.querySelector('[data-selected-label="'+target+'"]');
        if (label) label.textContent = c.name;
        onPick(c.hex, c.name, !!c.metallic);
      });
      wrap.appendChild(sw);
    });
  }

  function renderMascots(filter) {
    filter = (filter || '').toLowerCase();
    var grid = ROOT.querySelector('[data-target="mascots"]');
    if (!grid) return;
    var d = state.decals[getEditingView()];
    grid.innerHTML = '';
    MASCOTS.filter(function(m){
      return m.id.indexOf(filter) !== -1 || (m.name && m.name.toLowerCase().indexOf(filter) !== -1);
    }).forEach(function(m){
      var tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'hc-mascot';
      tile.setAttribute('aria-pressed', d.mascotId === m.id ? 'true' : 'false');
      // Build the tile with a preview area + name. The SVG fills in once loaded.
      tile.innerHTML =
        '<div class="hc-mascot-preview" data-mascot-preview="'+m.id+'"></div>' +
        '<div class="hc-mascot-label">'+escapeHtml(m.name)+'</div>';
      tile.addEventListener('click', function(){
        grid.querySelectorAll('.hc-mascot').forEach(function(x){x.setAttribute('aria-pressed','false');});
        tile.setAttribute('aria-pressed','true');
        var view = getEditingView();
        state.decals[view].mascotId = m.id;
        state.decals[view].mode = 'mascot';
        renderMascotColors();
        applyAllDecals();
        updateSummary();
      });
      grid.appendChild(tile);
      // Lazy load the SVG preview
      loadMascotSVG(m.id).then(function(svgText){
        var previewBox = tile.querySelector('[data-mascot-preview="'+m.id+'"]');
        if (!previewBox) return;
        // Recolor preview to white so it shows on the dark tile background
        var parser = new DOMParser();
        var doc = parser.parseFromString(svgText, 'image/svg+xml');
        var svgEl = doc.querySelector('svg');
        if (!svgEl) return;
        svgEl.querySelectorAll('path, polygon, polyline, rect, circle, ellipse, line').forEach(function(el){
          if (el.getAttribute('fill') !== 'none') el.setAttribute('fill', '#ffffff');
          if (el.getAttribute('stroke') && el.getAttribute('stroke') !== 'none') el.setAttribute('stroke', '#ffffff');
        });
        svgEl.setAttribute('width', '100%');
        svgEl.setAttribute('height', '100%');
        previewBox.appendChild(svgEl);
      }).catch(function(){});
    });
  }

  function renderFonts() {
    var wrap = ROOT.querySelector('[data-target="fonts"]');
    if (!wrap) return;
    var d = state.decals[getEditingView()];
    wrap.innerHTML = '';
    FONTS.forEach(function(f){
      var opt = document.createElement('button');
      opt.type = 'button';
      opt.className = 'hc-font';
      opt.setAttribute('aria-pressed', d.letterFont === f.name ? 'true' : 'false');
      opt.style.fontFamily = f.family;
      opt.style.fontWeight = f.weight;
      opt.innerHTML = 'A<span class="hc-font-name">'+escapeHtml(f.name)+'</span>';
      opt.addEventListener('click', function(){
        wrap.querySelectorAll('.hc-font').forEach(function(x){x.setAttribute('aria-pressed','false');});
        opt.setAttribute('aria-pressed','true');
        var view = getEditingView();
        state.decals[view].letterFont = f.name;
        state.decals[view].letterFontFamily = f.family;
        state.decals[view].letterFontWeight = f.weight;
        applyAllDecals();
      });
      wrap.appendChild(opt);
    });
  }

  function refreshDecalPalettes() {
    var palette = getDecalPalette();
    // For both sides, fallback if currently-selected color isn't in new palette
    ['right','left'].forEach(function(v){
      var d = state.decals[v];
      var found = palette.some(function(c){return c.hex.toUpperCase() === d.color.toUpperCase();});
      if (!found) { d.color = palette[0].hex; d.colorName = palette[0].name; }
      var foundL = palette.some(function(c){return c.hex.toUpperCase() === d.letterColor.toUpperCase();});
      if (!foundL) { d.letterColor = palette[0].hex; d.letterColorName = palette[0].name; }
    });
    // Update visible labels
    var active = state.decals[getEditingView()];
    var lbl2 = ROOT.querySelector('[data-selected-label="letter-color"]');
    if (lbl2) lbl2.textContent = active.letterColorName;
    renderPalette('letter-color', active.letterColor, function(c,n){
      var v = getEditingView();
      state.decals[v].letterColor = c; state.decals[v].letterColorName = n;
      applyAllDecals();
    }, palette);
    applyAllDecals();
  }

  function renderStripes() {
    var grid = ROOT.querySelector('[data-target="stripes"]');
    if (!grid) return;
    grid.innerHTML = '';
    var view = state.activeView;
    if (!isStripe(view)) return;
    var current = state.stripe;
    STRIPES.forEach(function(s){
      var opt = document.createElement('button');
      opt.type = 'button';
      opt.className = 'hc-stripe-opt';
      opt.setAttribute('aria-pressed', current.id === s.id ? 'true' : 'false');
      var preview = s.id === 'none' ? '' : '<div class="hc-stripe-preview"></div>';
      opt.innerHTML = preview + '<div class="hc-stripe-opt-name">'+escapeHtml(s.name)+'</div>';
      opt.addEventListener('click', function(){
        grid.querySelectorAll('.hc-stripe-opt').forEach(function(x){x.setAttribute('aria-pressed','false');});
        opt.setAttribute('aria-pressed','true');
        state.stripe.id = s.id;
        renderStripeColors();
        applyAllStripes();
        updateSummary();
      });
      grid.appendChild(opt);
    });
  }

  function renderStripeColors() {
    var view = state.activeView;
    var wrap = document.getElementById('hc-stripe-colors');
    if (!wrap || !isStripe(view)) return;
    var s = state.stripe;
    if (s.id === 'none') { wrap.innerHTML = ''; return; }
    var def = STRIPES.find(function(x){return x.id === s.id;});
    // For per-view stripes, load all variants and take max color count so
    // the picker doesn't flicker when user switches between front/back views.
    var colorCountPromise;
    if (def && def.perView) {
      colorCountPromise = Promise.all([
        loadStripeSVG(s.id, 'front').catch(function(){return null;}),
        loadStripeSVG(s.id, 'back').catch(function(){return null;})
      ]).then(function(texts){
        return Math.max.apply(null, texts.map(countStripeColors));
      });
    } else {
      colorCountPromise = loadStripeSVG(s.id, view).then(countStripeColors);
    }
    colorCountPromise.then(function(count){
      if (count === 0) { wrap.innerHTML = ''; return; }
      var html = '';
      for (var i = 1; i <= count; i++) {
        var nameKey = 'color' + i + 'Name';
        html += '<span class="hc-label">Stripe Color ' + i + '</span>' +
                '<div class="hc-swatches" data-target="stripe-color-' + i + '"></div>' +
                '<div class="hc-selected"><span class="hc-selected-label">Selected:</span>' +
                '<span data-selected-label="stripe-color-' + i + '">'+escapeHtml(s[nameKey] || '')+'</span></div>';
      }
      wrap.innerHTML = html;
      for (var j = 1; j <= count; j++) {
        (function(idx){
          var colorKey = 'color' + idx;
          var nameKey = 'color' + idx + 'Name';
          renderPalette('stripe-color-' + idx, s[colorKey], function(c,n){
            state.stripe[colorKey] = c;
            state.stripe[nameKey] = n;
            applyAllStripes();
            updateSummary();
          });
        })(j);
      }
    }).catch(function(err){
      console.error(err);
      wrap.innerHTML = '<div style="color:#888;font-size:12px;">Could not load stripe colors.</div>';
    });
  }

  function renderStripeControls() {
    renderStripes();
    renderStripeColors();
  }

  // ============================================================
  // SUMMARY
  // ============================================================
  function updateSummary() {
    function set(key, val) {
      var el = ROOT.querySelector('[data-summary="'+key+'"]');
      if (el) el.textContent = val;
    }
    set('shell', state.shellName + (state.shellMetallic ? ' (metallic)' : ''));
    set('mask', state.maskName);
    // Decals summary: describe each side
    function descDecal(d) {
      if (d.mode === 'mascot' && d.mascotId) {
        var mDef = MASCOTS.find(function(x){return x.id === d.mascotId;});
        var mName = mDef ? mDef.name : d.mascotId;
        return mName + ' (' + d.colorName + ')';
      }
      if (d.mode === 'lettering' && d.letterText) {
        var fdef = FONTS.find(function(f){return f.name === d.letterFont;});
        var t = (fdef && fdef.mixedCase) ? d.letterText : d.letterText.toUpperCase();
        var outlinePart = d.letterOutline ? ' + ' + d.letterOutlineColorName + ' outline' : '';
        return '"' + t + '" ' + d.letterFont + ' (' + d.letterColorName + outlinePart + ')';
      }
      if (d.mode === 'upload' && d.uploadName) return 'Upload: ' + d.uploadName;
      return 'None';
    }
    var rightDesc, leftDesc;
    if (state.mirrorSides) {
      var sourceDesc = descDecal(state.decals[state.mirrorSource]);
      rightDesc = (state.mirrorSource === 'right') ? sourceDesc : sourceDesc + ' (mirrored)';
      leftDesc = (state.mirrorSource === 'left') ? sourceDesc : sourceDesc + ' (mirrored)';
    } else {
      rightDesc = descDecal(state.decals.right);
      leftDesc = descDecal(state.decals.left);
    }
    set('decals', 'R: ' + rightDesc + ' / L: ' + leftDesc);
    // Stripes summary
    function descStripe(s) {
      if (s.id === 'none') return 'None';
      var def = STRIPES.find(function(x){return x.id === s.id;});
      if (!def) return 'Unknown';
      var name = def.name;
      var text = loadedStripeSVGs[s.id];
      var count = countStripeColors(text);
      if (count <= 1) return name + ' (' + s.color1Name + ')';
      if (count === 2) return name + ' (' + s.color1Name + ' / ' + s.color2Name + ')';
      return name + ' (' + s.color1Name + ' / ' + s.color2Name + ' / ' + s.color3Name + ')';
    }
    set('stripes', descStripe(state.stripe));
  }

  // ============================================================
  // SECTION TOGGLING
  // ============================================================
  $$('.hc-section-head').forEach(function(head){
    head.addEventListener('click', function(){
      var sec = head.closest('.hc-section');
      var collapsed = sec.classList.toggle('collapsed');
      head.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    });
  });

  // ============================================================
  // TABS
  // ============================================================
  $$('.hc-tab').forEach(function(tab){
    tab.addEventListener('click', function(){
      var name = tab.dataset.tab;
      $$('.hc-tab').forEach(function(t){t.setAttribute('aria-selected', t.dataset.tab === name ? 'true' : 'false');});
      $$('.hc-tab-panel').forEach(function(p){p.hidden = p.dataset.panel !== name;});
      var view = getEditingView();
      state.decals[view].mode = name;
      applyAllDecals();
    });
  });

  // ============================================================
  // INPUTS
  // ============================================================
  var letterInput = document.getElementById('hc-letter-input');
  if (letterInput) {
    letterInput.addEventListener('input', function(e){
      var view = getEditingView();
      state.decals[view].letterText = e.target.value;
      state.decals[view].mode = 'lettering';
      applyAllDecals();
      updateSummary();
    });
  }

  var mascotSearch = document.getElementById('hc-mascot-search');
  if (mascotSearch) mascotSearch.addEventListener('input', function(e){ renderMascots(e.target.value); });

  var sizeSlider = document.getElementById('hc-decal-size');
  var sizeVal = document.getElementById('hc-decal-size-val');
  if (sizeSlider && sizeVal) {
    sizeSlider.addEventListener('input', function(e){
      var view = getEditingView();
      state.decals[view].size = parseInt(e.target.value, 10);
      sizeVal.textContent = state.decals[view].size + '%';
      applyAllDecals();
    });
  }

  document.getElementById('hc-recenter').addEventListener('click', function(){
    var view = getEditingView();
    state.decals[view].offsetX = 0;
    state.decals[view].offsetY = 0;
    applyAllDecals();
  });

  // Mirror toggle
  var mirrorToggle = document.getElementById('hc-mirror-toggle');
  if (mirrorToggle) {
    mirrorToggle.addEventListener('change', function(e){
      state.mirrorSides = e.target.checked;
      if (state.mirrorSides && isSide(state.activeView)) {
        state.mirrorSource = state.activeView;
      }
      // Show/hide the mirror flip toggle based on sides match
      var mfw = document.getElementById('hc-mirror-flip-wrap');
      if (mfw) mfw.style.display = state.mirrorSides ? 'block' : 'none';
      applyAllDecals();
      refreshControlsForCurrentView();
      updateSummary();
    });
  }

  // Mirror flip toggle (flips the mirrored side's decal horizontally)
  var mirrorFlipToggle = document.getElementById('hc-mirror-flip-toggle');
  if (mirrorFlipToggle) {
    mirrorFlipToggle.checked = !!state.mirrorDecalFlip;
    mirrorFlipToggle.addEventListener('change', function(e){
      state.mirrorDecalFlip = e.target.checked;
      applyAllDecals();
    });
  }

  // ============================================================
  // UPLOAD
  // ============================================================
  // ============================================================
  // BACKGROUND REMOVAL (uses @imgly/background-removal in-browser)
  // Best balance of quality + reliability among free options tested.
  // The isnet_fp16 model variant handles holes in shapes (like inside
  // of letters O, R, A) better than the default model.
  // ============================================================
  var bgRemovalLib = null;
  var bgRemovalLoading = null;

  function loadBgRemovalLib() {
    if (bgRemovalLib) return Promise.resolve(bgRemovalLib);
    if (bgRemovalLoading) return bgRemovalLoading;
    bgRemovalLoading = new Promise(function(resolve, reject){
      var script = document.createElement('script');
      script.type = 'module';
      script.textContent = [
        'import { removeBackground } from "https://esm.sh/@imgly/background-removal@1.5.5";',
        'window.__gdsImglyRemoveBackground = removeBackground;',
        'window.dispatchEvent(new Event("__gds_imgly_ready"));'
      ].join('\n');
      function onReady() {
        window.removeEventListener('__gds_imgly_ready', onReady);
        bgRemovalLib = window.__gdsImglyRemoveBackground;
        resolve(bgRemovalLib);
      }
      window.addEventListener('__gds_imgly_ready', onReady);
      script.onerror = function(){ reject(new Error('Failed to load background removal library')); };
      document.head.appendChild(script);
      setTimeout(function(){
        if (!bgRemovalLib) reject(new Error('Background removal library timeout'));
      }, 30000);
    });
    return bgRemovalLoading;
  }

  function dataUrlToBlob(dataUrl) {
    var parts = dataUrl.split(',');
    var mime = parts[0].match(/:(.*?);/)[1];
    var bin = atob(parts[1]);
    var arr = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
    return new Blob([arr], { type: mime });
  }

  function blobToDataUrl(blob) {
    return new Promise(function(resolve, reject){
      var reader = new FileReader();
      reader.onload = function(e){ resolve(e.target.result); };
      reader.onerror = function(){ reject(new Error('FileReader failed')); };
      reader.readAsDataURL(blob);
    });
  }

  function removeBackgroundFromDataUrl(dataUrl) {
    return loadBgRemovalLib().then(function(removeBackground){
      var blob = dataUrlToBlob(dataUrl);
      return removeBackground(blob, { model: 'isnet_fp16' });
    }).then(function(resultBlob){
      return blobToDataUrl(resultBlob);
    });
  }

  // ============================================================
  // UPLOAD HANDLING
  // ============================================================
  var uploadZone = document.getElementById('hc-upload-zone');
  var uploadInput = document.getElementById('hc-upload-input');
  var uploadPreview = document.getElementById('hc-upload-preview');

  if (uploadZone && uploadInput) {
    uploadZone.addEventListener('click', function(){ uploadInput.click(); });
    uploadInput.addEventListener('change', function(e){ handleFile(e.target.files[0]); });
    uploadZone.addEventListener('dragover', function(e){ e.preventDefault(); uploadZone.classList.add('dragging'); });
    uploadZone.addEventListener('dragleave', function(){ uploadZone.classList.remove('dragging'); });
    uploadZone.addEventListener('drop', function(e){
      e.preventDefault();
      uploadZone.classList.remove('dragging');
      if (e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);
    });
  }

  function handleFile(file) {
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) { showToast('File too large. Max 10MB.'); return; }
    var reader = new FileReader();
    reader.onload = function(e){
      var view = getEditingView();
      var originalDataUrl = e.target.result;
      // First show the original immediately
      state.decals[view].uploadDataUrl = originalDataUrl;
      state.decals[view].uploadName = file.name;
      state.decals[view].mode = 'upload';
      renderUploadPreview(file.name, originalDataUrl, true);
      applyAllDecals();
      updateSummary();

      // Now run background removal in the background (non-blocking)
      // SVGs already have transparency, so skip them
      if (file.type === 'image/svg+xml') return;

      removeBackgroundFromDataUrl(originalDataUrl).then(function(cleanedDataUrl){
        // Only update if user is still on this view's upload (didn't switch / clear)
        if (state.decals[view].uploadName !== file.name) return;
        state.decals[view].uploadDataUrl = cleanedDataUrl;
        renderUploadPreview(file.name, cleanedDataUrl, false);
        applyAllDecals();
        showToast('Background removed');
      }).catch(function(err){
        console.warn('[GDS] Background removal failed (keeping original):', err);
        renderUploadPreview(file.name, originalDataUrl, false, true);
      });
    };
    reader.readAsDataURL(file);
  }

  function renderUploadPreview(filename, dataUrl, isProcessing, removalFailed) {
    if (!uploadPreview) return;
    var statusBadge = '';
    if (isProcessing) {
      statusBadge = '<span class="hc-upload-status hc-upload-status--processing">Removing background…</span>';
    } else if (removalFailed) {
      statusBadge = '<span class="hc-upload-status hc-upload-status--warn">Auto-removal failed (using original)</span>';
    } else {
      statusBadge = '<span class="hc-upload-status hc-upload-status--ok">Ready</span>';
    }
    uploadPreview.innerHTML =
      '<div class="hc-upload-preview">' +
        '<img src="'+dataUrl+'" alt="">' +
        '<div class="hc-upload-info">' +
          '<span class="hc-upload-name">'+escapeHtml(filename)+'</span>' +
          statusBadge +
        '</div>' +
        '<button type="button" class="hc-upload-clear" id="hc-clear-upload">Remove</button>' +
      '</div>';
    document.getElementById('hc-clear-upload').addEventListener('click', clearUpload);
  }

  function clearUpload() {
    var view = getEditingView();
    state.decals[view].uploadDataUrl = null;
    state.decals[view].uploadName = '';
    uploadPreview.innerHTML = '';
    applyAllDecals();
    updateSummary();
  }

  // ============================================================
  // VIEW CLICK = SWITCH ACTIVE VIEW
  // ============================================================
  $$('.hc-view').forEach(function(v){
    v.addEventListener('click', function(){ setActiveView(v.dataset.view); });
  });

  // ============================================================
  // RESET
  // ============================================================
  document.getElementById('hc-reset').addEventListener('click', function(){
    if (!confirm('Reset all design choices?')) return;
    location.reload();
  });

  // ============================================================
  // ACTION BAR - DOWNLOAD / EMAIL / SHARE
  // ============================================================
  // Lazy-load html2canvas only when needed
  function loadScript(src) {
    return new Promise(function(resolve, reject){
      var s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function buildDesignSummary() {
    function descDecal(d) {
      if (d.mode === 'mascot' && d.mascotId) {
        var mDef2 = MASCOTS.find(function(x){return x.id === d.mascotId;});
        var mName2 = mDef2 ? mDef2.name : d.mascotId;
        return 'Mascot: ' + mName2 + ' in ' + d.colorName;
      }
      if (d.mode === 'lettering' && d.letterText) {
        var fdef2 = FONTS.find(function(f){return f.name === d.letterFont;});
        var t2 = (fdef2 && fdef2.mixedCase) ? d.letterText : d.letterText.toUpperCase();
        var outlinePart2 = d.letterOutline ? ' with ' + d.letterOutlineColorName + ' outline' : '';
        return 'Lettering: "' + t2 + '" in ' + d.letterFont + ' / ' + d.letterColorName + outlinePart2;
      }
      if (d.mode === 'upload' && d.uploadName) return 'Custom upload: ' + d.uploadName;
      return 'None';
    }
    function descStripe(s) {
      if (s.id === 'none') return 'None';
      var def = STRIPES.find(function(x){return x.id === s.id;});
      if (!def) return 'Unknown';
      var name = def.name;
      var text = loadedStripeSVGs[s.id];
      var count = countStripeColors(text);
      if (count <= 1) return name + ' in ' + s.color1Name;
      if (count === 2) return name + ' in ' + s.color1Name + ' / ' + s.color2Name;
      return name + ' in ' + s.color1Name + ' / ' + s.color2Name + ' / ' + s.color3Name;
    }
    var rDesc, lDesc;
    if (state.mirrorSides) {
      var sourceDesc = descDecal(state.decals[state.mirrorSource]);
      rDesc = (state.mirrorSource === 'right') ? sourceDesc : sourceDesc + ' (mirrored from left)';
      lDesc = (state.mirrorSource === 'left') ? sourceDesc : sourceDesc + ' (mirrored from right)';
    } else {
      rDesc = descDecal(state.decals.right);
      lDesc = descDecal(state.decals.left);
    }
    return {
      shell: state.shellName + (state.shellMetallic ? ' (metallic)' : ''),
      mask: state.maskName,
      rightDecal: rDesc,
      leftDecal: lDesc,
      stripe: descStripe(state.stripe)
    };
  }

  // ============================================================
  // SUPABASE LEAD TRACKING
  // ============================================================
  // Inserts one row into helmet_designs table when customer info is captured.
  // Non-blocking: failures are logged but don't interrupt the user.
  function trackLeadToSupabase() {
    var supabaseUrl = ROOT.dataset.supabaseUrl;
    var supabaseKey = ROOT.dataset.supabaseKey;
    if (!supabaseUrl || !supabaseKey) {
      return Promise.reject(new Error('Supabase config missing'));
    }
    var payload = {
      team_name: state.customer.teamName,
      contact_name: state.customer.contactName,
      email: state.customer.email,
      phone: state.customer.phone,
      design_summary: buildDesignSummary(),
      design_link: buildShareLink(),
      user_agent: navigator.userAgent || '',
      referrer: document.referrer || ''
    };
    return fetch(supabaseUrl + '/rest/v1/helmet_designs', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': supabaseKey,
        'Authorization': 'Bearer ' + supabaseKey,
        'Prefer': 'return=minimal'
      },
      body: JSON.stringify(payload)
    }).then(function(r){
      if (!r.ok) {
        return r.text().then(function(t){ throw new Error('Supabase ' + r.status + ': ' + t); });
      }
      return true;
    });
  }

  // ============================================================
  // CUSTOMER INFO MODAL
  // ============================================================
  // Returns a Promise that resolves when customer info is captured.
  // If already captured this session, resolves immediately.
  function requireCustomerInfo() {
    return new Promise(function(resolve, reject){
      if (state.customer.captured) { resolve(state.customer); return; }
      var modal = document.getElementById('hc-customer-modal');
      var form = document.getElementById('hc-customer-form');
      var errEl = document.getElementById('hc-modal-error');
      var cancelBtn = document.getElementById('hc-modal-cancel');
      if (!modal || !form) { reject(new Error('Modal not found')); return; }
      // Restore any prior entries (so user doesn't lose work)
      form.elements.teamName.value = state.customer.teamName || '';
      form.elements.contactName.value = state.customer.contactName || '';
      form.elements.email.value = state.customer.email || '';
      form.elements.phone.value = state.customer.phone || '';
      errEl.textContent = '';
      modal.setAttribute('aria-hidden','false');
      setTimeout(function(){ form.elements.teamName.focus(); }, 50);

      function cleanup() {
        modal.setAttribute('aria-hidden','true');
        form.removeEventListener('submit', onSubmit);
        cancelBtn.removeEventListener('click', onCancel);
      }
      function onSubmit(e) {
        e.preventDefault();
        var data = {
          teamName: form.elements.teamName.value.trim(),
          contactName: form.elements.contactName.value.trim(),
          email: form.elements.email.value.trim(),
          phone: form.elements.phone.value.trim()
        };
        if (!data.teamName || !data.contactName || !data.email || !data.phone) {
          errEl.textContent = 'All fields are required.';
          return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
          errEl.textContent = 'Please enter a valid email address.';
          return;
        }
        Object.assign(state.customer, data, { captured: true });
        // Fire-and-forget lead tracking to Supabase. We do NOT block the
        // download/share/email action on this - the user gets their proof
        // even if tracking fails (network issues, etc).
        trackLeadToSupabase().catch(function(err){
          console.warn('[GDS] Lead tracking failed (non-blocking):', err);
        });
        cleanup();
        resolve(state.customer);
      }
      function onCancel() {
        cleanup();
        reject(new Error('Cancelled by user'));
      }
      form.addEventListener('submit', onSubmit);
      cancelBtn.addEventListener('click', onCancel);
    });
  }

  // ============================================================
  // BRANDED RENDER LAYOUT
  // ============================================================
  // Build a hidden, off-screen DOM tree that has the helmet grid with
  // branded header bar (logo + team name) and footer (contact + URL).
  // html2canvas captures this instead of the live .hc-views which has
  // the green selection border baked in.
  function buildBrandedRenderTree() {
    var customer = state.customer;
    var summary = buildDesignSummary();
    var logoUrl = ROOT.dataset.logoUrl || '';

    // Clone the .hc-views element (so we get the actual rendered helmets) and
    // strip the active-state class so no green border appears.
    var viewsClone = ROOT.querySelector('.hc-views').cloneNode(true);
    viewsClone.querySelectorAll('.hc-view-active').forEach(function(el){
      el.classList.remove('hc-view-active');
    });
    // Also remove the small "Front" / "Rear" labels' lime active highlight if any
    viewsClone.querySelectorAll('.hc-view').forEach(function(el){
      el.style.border = 'none';
      el.style.background = '#f2f2f2';
    });
    viewsClone.querySelectorAll('.hc-view-label').forEach(function(el){
      el.style.background = '#333';
      el.style.color = '#fff';
    });

    // Build wrapper
    var wrap = document.createElement('div');
    wrap.id = 'hc-render-tree';
    wrap.style.cssText = [
      'position:fixed','left:-10000px','top:0','width:900px','background:#f7f7f7',
      'font-family:Inter,Arial,sans-serif','color:#1a1a1a','padding:0','box-sizing:border-box'
    ].join(';');

    // Header bar (black)
    var header = document.createElement('div');
    header.style.cssText = [
      'background:#000','color:#fff','padding:18px 28px','display:flex',
      'justify-content:space-between','align-items:center','gap:20px'
    ].join(';');
    header.innerHTML =
      '<div style="display:flex;align-items:center;">' +
        (logoUrl ? '<img src="'+escapeAttr(logoUrl)+'" alt="Game Day Skinz" crossorigin="anonymous" style="height:48px;width:auto;display:block;">' : '<span style="font-family:Oswald,sans-serif;font-weight:700;font-size:24px;letter-spacing:0.05em;">GAME DAY SKINZ</span>') +
      '</div>' +
      '<div style="text-align:right;">' +
        '<div style="font-family:Oswald,Inter,sans-serif;font-weight:700;font-size:22px;letter-spacing:0.05em;text-transform:uppercase;">'+escapeHtml(customer.teamName)+'</div>' +
        '<div style="font-size:11px;letter-spacing:0.08em;text-transform:uppercase;opacity:0.7;margin-top:2px;">HELMET DESIGN PROOF</div>' +
      '</div>';

    // Body: light background containing the helmet grid
    var body = document.createElement('div');
    body.style.cssText = 'padding:24px;background:#f7f7f7;';
    viewsClone.style.background = '#f7f7f7';
    viewsClone.style.margin = '0';
    viewsClone.style.padding = '0';
    body.appendChild(viewsClone);

    // Specs section
    var specs = document.createElement('div');
    specs.style.cssText = 'padding:20px 28px;background:#fff;border-top:2px solid #000;font-size:13px;line-height:1.6;';
    var specsHtml = '<div style="font-family:Oswald,Inter,sans-serif;font-weight:700;font-size:14px;letter-spacing:0.05em;text-transform:uppercase;margin-bottom:10px;color:#000;">Design Specifications</div>';
    specsHtml += '<div style="display:grid;grid-template-columns:1fr 1fr;gap:6px 24px;">';
    specsHtml += '<div><strong>Shell:</strong> '+escapeHtml(summary.shell)+'</div>';
    specsHtml += '<div><strong>Facemask:</strong> '+escapeHtml(summary.mask)+'</div>';
    specsHtml += '<div><strong>Stripe:</strong> '+escapeHtml(summary.stripe)+'</div>';
    specsHtml += '</div>';
    specs.innerHTML = specsHtml;

    // Footer: contact info + URL
    var footer = document.createElement('div');
    footer.style.cssText = [
      'background:#1a1a1a','color:#fff','padding:14px 28px','display:flex',
      'justify-content:space-between','align-items:center','font-size:12px','gap:20px'
    ].join(';');
    footer.innerHTML =
      '<div style="line-height:1.5;">' +
        '<div><strong>'+escapeHtml(customer.contactName)+'</strong></div>' +
        '<div>'+escapeHtml(customer.email)+' &middot; '+escapeHtml(customer.phone)+'</div>' +
      '</div>' +
      '<div style="text-align:right;font-family:Oswald,Inter,sans-serif;font-weight:700;letter-spacing:0.05em;color:#c9f33f;">info@gamedayskinz.com <span style="color:#555;">|</span> gamedayskinz.com</div>';

    wrap.appendChild(header);
    wrap.appendChild(body);
    wrap.appendChild(specs);
    wrap.appendChild(footer);
    document.body.appendChild(wrap);
    return wrap;
  }

  function escapeAttr(s) {
    return String(s||'').replace(/"/g, '&quot;').replace(/&/g,'&amp;');
  }

  // ============================================================
  // DOWNLOAD ACTIONS (gated by customer info)
  // ============================================================

  // PNG download via html2canvas
  document.getElementById('hc-action-png').addEventListener('click', function(){
    var btn = this;
    requireCustomerInfo().then(function(){
      btn.disabled = true;
      btn.textContent = 'Generating...';
      var ready = window.html2canvas ? Promise.resolve() : loadScript('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js');
      var renderTree;
      return ready.then(function(){
        renderTree = buildBrandedRenderTree();
        // small delay so logo image starts loading
        return new Promise(function(r){ setTimeout(r, 100); });
      }).then(function(){
        return window.html2canvas(renderTree, { backgroundColor:'#f7f7f7', scale:2, logging:false, useCORS:true });
      }).then(function(canvas){
        var link = document.createElement('a');
        link.download = 'gds-helmet-design-' + (state.customer.teamName.replace(/\s+/g,'-').toLowerCase() || 'design') + '-' + Date.now() + '.png';
        link.href = canvas.toDataURL('image/png');
        link.click();
        showToast('PNG downloaded');
        if (renderTree && renderTree.parentNode) renderTree.parentNode.removeChild(renderTree);
      });
    }).catch(function(err){
      if (err && err.message === 'Cancelled by user') return;
      console.error(err);
      showToast('Could not generate PNG');
    }).finally(function(){
      btn.disabled = false;
      btn.textContent = 'Download PNG';
    });
  });

  // PDF download via jsPDF + html2canvas (renders the same branded tree)
  document.getElementById('hc-action-pdf').addEventListener('click', function(){
    var btn = this;
    requireCustomerInfo().then(function(){
      btn.disabled = true;
      btn.textContent = 'Generating...';
      var needJsPdf = window.jspdf ? Promise.resolve() : loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js');
      var needHtml2Canvas = window.html2canvas ? Promise.resolve() : loadScript('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js');
      var renderTree;
      return Promise.all([needJsPdf, needHtml2Canvas]).then(function(){
        renderTree = buildBrandedRenderTree();
        return new Promise(function(r){ setTimeout(r, 100); });
      }).then(function(){
        return window.html2canvas(renderTree, { backgroundColor:'#f7f7f7', scale:2, logging:false, useCORS:true });
      }).then(function(canvas){
        var pdf = new window.jspdf.jsPDF({ orientation:'portrait', unit:'mm', format:'letter' });
        var pageW = pdf.internal.pageSize.getWidth();
        var pageH = pdf.internal.pageSize.getHeight();
        var imgData = canvas.toDataURL('image/png');
        // Fit image to page width with small margin
        var margin = 8;
        var imgW = pageW - (margin * 2);
        var imgH = canvas.height * imgW / canvas.width;
        if (imgH > pageH - (margin * 2)) {
          imgH = pageH - (margin * 2);
          imgW = canvas.width * imgH / canvas.height;
        }
        var xOffset = (pageW - imgW) / 2;
        pdf.addImage(imgData, 'PNG', xOffset, margin, imgW, imgH);
        pdf.save('gds-helmet-design-' + (state.customer.teamName.replace(/\s+/g,'-').toLowerCase() || 'design') + '-' + Date.now() + '.pdf');
        showToast('PDF downloaded');
        if (renderTree && renderTree.parentNode) renderTree.parentNode.removeChild(renderTree);
      });
    }).catch(function(err){
      if (err && err.message === 'Cancelled by user') return;
      console.error(err);
      showToast('Could not generate PDF');
    }).finally(function(){
      btn.disabled = false;
      btn.textContent = 'Download PDF';
    });
  });

  // Email - mailto with summary (now includes captured customer info)
  document.getElementById('hc-action-email').addEventListener('click', function(){
    requireCustomerInfo().then(function(){
      var c = state.customer;
      var summary = buildDesignSummary();
      var subject = 'Helmet Design Proof Request - ' + c.teamName;
      var body = [
        'Hi GDS Art Team,',
        '',
        'I designed a helmet using the configurator and would like a proof.',
        '',
        'Design specs:',
        'Shell: ' + summary.shell,
        'Facemask: ' + summary.mask,
        'Stripe: ' + summary.stripe,
        '',
        'Shareable design link: ' + buildShareLink(),
        '',
        'My contact info:',
        'Team: ' + c.teamName,
        'Name: ' + c.contactName,
        'Email: ' + c.email,
        'Phone: ' + c.phone,
        '',
        'Thanks!'
      ].join('\r\n');
      var url = 'mailto:' + ART_TEAM_EMAIL + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
      window.location.href = url;
    }).catch(function(err){
      if (err && err.message === 'Cancelled by user') return;
      console.error(err);
    });
  });

  // Share link - encode state in URL hash
  function buildShareLink() {
    var compact = {
      s: state.shellColor, sn: state.shellName, sm: state.shellMetallic ? 1 : 0,
      m: state.maskColor, mn: state.maskName,
      mir: state.mirrorSides ? 1 : 0,
      mdf: state.mirrorDecalFlip ? 1 : 0,
      rd: state.decals.right,
      ld: state.decals.left,
      st: state.stripe
    };
    try {
      var enc = btoa(unescape(encodeURIComponent(JSON.stringify(compact))));
      return window.location.origin + window.location.pathname + '#design=' + enc;
    } catch (e) { return window.location.href; }
  }

  document.getElementById('hc-action-share').addEventListener('click', function(){
    requireCustomerInfo().then(function(){
      var url = buildShareLink();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function(){ showToast('Link copied to clipboard'); });
      } else {
        window.prompt('Copy this link:', url);
      }
    }).catch(function(err){
      if (err && err.message === 'Cancelled by user') return;
      console.error(err);
    });
  });

  // Restore from hash if present
  function restoreFromHash() {
    var hash = window.location.hash || '';
    var m = hash.match(/design=([^&]+)/);
    if (!m) return;
    try {
      var compact = JSON.parse(decodeURIComponent(escape(atob(m[1]))));
      state.shellColor = compact.s; state.shellName = compact.sn;
      state.shellMetallic = !!compact.sm;
      state.maskColor = compact.m; state.maskName = compact.mn;
      state.mirrorSides = !!compact.mir;
      if (compact.mdf !== undefined) state.mirrorDecalFlip = !!compact.mdf;
      if (compact.rd) Object.assign(state.decals.right, compact.rd);
      if (compact.ld) Object.assign(state.decals.left, compact.ld);
      if (compact.st) Object.assign(state.stripe, compact.st);
    } catch (e) { console.warn('Could not restore from hash', e); }
  }

  // ============================================================
  // INIT
  // ============================================================
  function initRenders() {
    renderPalette('shell', state.shellColor, function(c,n,metallic){
      state.shellColor=c;
      state.shellName=n;
      state.shellMetallic = !!metallic;
      applyHelmetToAll();
      updateSummary();
    }, RIDDELL_GLOSS);
    renderPalette('mask', state.maskColor, function(c,n){ state.maskColor=c; state.maskName=n; applyHelmetToAll(); updateSummary(); });
    var active = state.decals.right;
    renderPalette('letter-color', active.letterColor, function(c,n){
      var v = getEditingView();
      state.decals[v].letterColor = c; state.decals[v].letterColorName = n;
      applyAllDecals();
    }, getDecalPalette());
    renderPalette('letter-outline-color', active.letterOutlineColor, function(c,n){
      var v = getEditingView();
      state.decals[v].letterOutlineColor = c;
      state.decals[v].letterOutlineColorName = n;
      applyAllDecals();
    }, getDecalPalette());
    // Wire up the outline toggle
    var outlineToggle = document.getElementById('hc-letter-outline-toggle');
    var outlineControls = document.getElementById('hc-letter-outline-controls');
    if (outlineToggle) {
      // Sync initial state from active decal
      outlineToggle.checked = !!active.letterOutline;
      if (outlineControls) outlineControls.style.display = outlineToggle.checked ? 'block' : 'none';
      outlineToggle.addEventListener('change', function(e){
        var v = getEditingView();
        state.decals[v].letterOutline = e.target.checked;
        if (outlineControls) outlineControls.style.display = e.target.checked ? 'block' : 'none';
        applyAllDecals();
        updateSummary();
      });
    }
    renderMascots();
    renderMascotColors();
    renderFonts();
    renderStripes();
  }

  function init() {
    restoreFromHash();
    initRenders();
    updateSummary();
    setActiveView('right');
    loadAllSVGs().then(function(){
      applyHelmetToAll();
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          applyAllDecals();
          applyAllStripes();
          setupDrag();
        });
      });
    }).catch(function(err){
      console.error('Helmet SVG load failed:', err);
      showToast('Could not load helmet graphics');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();